$(document).on('click', 'a', function (e) {
  $('[data-bs-toggle=popover]').each(function () {
    if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
      $(this).closest('.popover').remove();
    }
  });
});

$(document).on('click', '.js-popover-custom', function(e) {
  e.preventDefault();

  const $el         = this;

  $('.js-popover-custom').not($el).popover('hide').popover('dispose');

  showDeleteConfirmPopover($el);
});

function showDeleteConfirmPopover(el) {
  const itemId         = $(el).data('item-id');
  const modelName      = $(el).data('model-name');
  const controllerName = $(el).data('controller-name');
  const isClearClient  = $(el).data('is-clear-client');
  const isItemName     = $(el).data('item-name');
  const isEdit         = $(el).data('is-edit');
  const backUrl        = $(el).data('back-url');
  const requestMethod  = $(el).data('request-method');
  const callback       = $(el).data('callback');
  let   title          = $(el).data('js-popover-title') || 'この経費科目を削除しますか？';

  const content = `<div class="text-center js-popover-content" aria-back-url=${backUrl} aria-request-method=${requestMethod} aria-item-id=${itemId} aria-model-name=${modelName} aria-controller-name=${controllerName} aria-is-edit=${isEdit} aria-is-clear-client=${isClearClient} aria-item-name=${isItemName} aria-callback=${callback}><span class="btn btn-default js-btn-cancel me-2">いいえ</span><span class="btn btn-primary js-btn-ok">はい</span></div>`;

  showPopover(el, title, content);
  if (controllerName == 'expenses') {
    $('.popover-custom-area').addClass('custom-area');
    $('.popover-arrow').addClass('custom-arrow');
  }
}

$(document).on('click', '.remove-field-dynamic', function (e) {
  e.preventDefault();
  window.removeFieldDynamicContainter = $(e.target).closest('.nested-fields');
});

$(document).on('click', '.popover-custom-area .js-btn-ok', function(e) {
  e.preventDefault();

  const $popoverContainer = $(this).parents('.popover');
  const isClearClient = $(this).parents('.js-popover-content').attr('aria-is-clear-client');
  const isEdit = $(this).parents('.js-popover-content').attr('aria-is-edit');
  const id = $(this).parents('.js-popover-content').attr('aria-item-id');
  const modelName = $(this).parents('.js-popover-content').attr('aria-model-name');
  const itemName = $(this).parents('.js-popover-content').attr('aria-item-name');
  const backUrl = $(this).parents('.js-popover-content').attr('aria-back-url');
  const callback = $(this).parents('.js-popover-content').attr('aria-callback');
  const responseFormat = $('#js-popover-custom-' + id).data('response-format');

  var requestMethod = $(this).parents('.js-popover-content').attr('aria-request-method');
  requestMethod = (requestMethod == 'undefined' || requestMethod == '' || requestMethod == null) ? 'DELETE' : requestMethod;
  if (itemName !== "undefined") {
    $(itemName).trigger('click');
  } else {
    if (isClearClient == 'true') {
      let $nestedElm = window.removeFieldDynamicContainter;
      if ($nestedElm == undefined) $nestedElm = $('#js-popover-custom-' + id).closest('.nested-fields');
      $(this).closest('.popover').remove();
      if (isEdit == 'true') {

        $nestedElm.find('.destroy-mode').val(true);
        $nestedElm.hide();
        removeEstimateItemWithLevel($nestedElm);
        window.updateAllPrices();
      } else {
        $nestedElm.remove();
      }
    } else {
      $(this).closest('.popover').remove();
      $.ajax({
        url: modelName,
        method: requestMethod,
        data: { 'authenticity_token': $('meta[name="csrf-token"]').attr('content') },
        dataType: responseFormat === 'json' ? 'json' : undefined
      }).done(function (response) {
        if (response && response.message) {
          alert(response.message);
        }

        if (backUrl == "reload") {
          window.location.reload();
        } else if (backUrl !== "undefined") {
          window.location.href = backUrl;
        }
        // $('.card .item-row-' + id).hide('slow');
      }).fail(function (xhr) {
        const message = xhr.responseJSON && xhr.responseJSON.message;
        if (message) {
          alert(message);
        }
      });
    }
  }
  $popoverContainer.remove();
  if (callback !== "undefined") {
    window[callback]();
  }
});

$(document).on('click', '.js-popover-partner', function(e) {
  e.preventDefault();
  $('.js-popover-partner').not($(this)).popover('hide')

  const title = '本当に削除しますか?';
  const content = `<div class="text-center js-popover-content"><span class="btn btn-default js-btn-cancel me-2">いいえ</span><span class="btn btn-primary js-btn-ok-partner">はい</span></div>`;
  const _this = $(this);
  showPopover(_this, title, content)
});

$(document).on('click', '.popover-custom-area .js-btn-cancel', function(e) {
  e.preventDefault();

  $(this).closest('.popover').remove();
});

const showPopover = (current, title, content) => {
  $(current).popover({
    html: true,
    title: title,
    content: content,
    placement: 'bottom',
    template: '<div class="popover popover-custom-area" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
  }).popover('show');
}


function removeEstimateItemWithLevel($row) {
  let level = parseInt($row.find(".level-select").val(), 10);
    let rowsToDelete = [$row];
    let isDeleting = true;

    if ([1, 2, 3].includes(level)) {
        let nextRows = $row.nextAll(".nested-fields:visible");
        nextRows.each(function () {
            let currentLevel = parseInt($(this).find(".level-select").val(), 10);
            let isBlankItem = isNaN(currentLevel);
            if (!isNaN(currentLevel) && currentLevel <= level) {
                isDeleting = false;
            }

            if (isDeleting) {
                if (isBlankItem || currentLevel > level) {
                    rowsToDelete.push($(this));
                }
            }
        });
    }

    rowsToDelete.forEach(function ($row) {
        let isEdit = $row.find(".destroy-mode").length > 0;
        if (isEdit) {
            $row.find(".destroy-mode").val(true);
            $row.hide();
        } else {
            $row.remove();
        }
    });

    setTimeout(function () {
        if (typeof window.updateAllPrices === "function") {
            window.updateAllPrices();
        }
    }, 100);
}
